export default function promiseAll(promises) {
    return Promise.all(promises);
}